import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';

import { Article } from '../../types/article';
import { Pagination } from '../../types/pagination';

type ArticleIndexRequest = {
  keyword?: string;
  category_slug?: string;
  tag_slug?: string;
  is_pickup?: boolean;
  is_information?: boolean;
  page?: number;
  per_page?: number;
  sort?: string;
  direction?: string;
};

type ArticleIndexResponse = {
  data: Article[];
  pagination: Pagination;
};

type ArticleShowResponse = Article;

export const articleApiClient = {
  index: async (params: ArticleIndexRequest = {}): Promise<ApiResult<ArticleIndexResponse>> => {
    return await axiosClient.get('/company/articles', { params });
  },
  show: async (id: number): Promise<ApiResult<ArticleShowResponse>> => {
    return await axiosClient.get(`/company/articles/${id}`);
  },
};
